"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditReportReferralCode = exports.GeneralReferralCode = void 0;
/**
 * Conditions that invoke a referral to the loan officer
 */
var GeneralReferralCode;
(function (GeneralReferralCode) {
    GeneralReferralCode["BANKRUPT"] = "BANKRUPT";
    GeneralReferralCode["BORROWER_INCOME_ON_DECLINE"] = "BORROWER_INCOME_ON_DECLINE";
    GeneralReferralCode["BORROWER_IS_TOO_YOUNG"] = "BORROWER_IS_TOO_YOUNG";
    GeneralReferralCode["BORROWER_SHORT_JOB_DURATION"] = "BORROWER_SHORT_JOB_DURATION";
    GeneralReferralCode["BORROWER_UNDERAGE"] = "BORROWER_UNDERAGE";
    GeneralReferralCode["BORROWER_UNDER_TWENTY_ONE"] = "BORROWER_UNDER_TWENTY_ONE";
    GeneralReferralCode["BORROWER_UNVERIFIED_INCOME"] = "BORROWER_UNVERIFIED_INCOME";
    GeneralReferralCode["CASH_OUT_NOT_AVAILABLE"] = "CASH_OUT_NOT_AVAILABLE";
    GeneralReferralCode["CO_BORROWER_INCOME_ON_DECLINE"] = "CO_BORROWER_INCOME_ON_DECLINE";
    GeneralReferralCode["CO_BORROWER_IS_TOO_YOUNG"] = "CO_BORROWER_IS_TOO_YOUNG";
    GeneralReferralCode["CO_BORROWER_NON_CITIZEN"] = "CO_BORROWER_NON_CITIZEN";
    GeneralReferralCode["CO_BORROWER_SHORT_JOB_DURATION"] = "CO_BORROWER_SHORT_JOB_DURATION";
    GeneralReferralCode["CO_BORROWER_UNDERAGE"] = "CO_BORROWER_UNDERAGE";
    GeneralReferralCode["CO_BORROWER_UNDER_TWENTY_ONE"] = "CO_BORROWER_UNDER_TWENTY_ONE";
    GeneralReferralCode["CO_BORROWER_UNVERIFIED_INCOME"] = "CO_BORROWER_UNVERIFIED_INCOME";
    GeneralReferralCode["CREDIT_REFERRAL"] = "CREDIT_REFERRAL";
    GeneralReferralCode["DOWN_PAYMENT"] = "DOWN_PAYMENT";
    GeneralReferralCode["FORECLOSURE"] = "FORECLOSURE";
    GeneralReferralCode["HAS_CURRENT_ESCROW"] = "HAS_CURRENT_ESCROW";
    GeneralReferralCode["HAS_MORE_THAN_ONE_HOME_OR_LIEN"] = "HAS_MORE_THAN_ONE_HOME_OR_LIEN";
    GeneralReferralCode["HAS_TAXES_SET_TOO_LOW"] = "HAS_TAXES_SET_TOO_LOW";
    GeneralReferralCode["HAS_HOME_VALUE_SET_TOO_LOW"] = "HAS_HOME_VALUE_SET_TOO_LOW";
    GeneralReferralCode["HAS_HOME_VALUE_SET_TOO_HIGH"] = "HAS_HOME_VALUE_SET_TOO_HIGH";
    GeneralReferralCode["HAS_AUTO_PRICE_SET_TOO_HIGH"] = "HAS_AUTO_PRICE_SET_TOO_HIGH";
    GeneralReferralCode["HAS_NO_CURRENT_CHECKING_ACCOUNT"] = "HAS_NO_CURRENT_CHECKING_ACCOUNT";
    GeneralReferralCode["HOME_EQUITY_BORROW_AMOUNT_LOW"] = "HOME_EQUITY_BORROW_AMOUNT_LOW";
    GeneralReferralCode["INSUFFICIENT_MONTHLY_PAYMENT"] = "INSUFFICIENT_MONTHLY_PAYMENT";
    GeneralReferralCode["IS_SALVAGE_TITLE"] = "IS_SALVAGE_TITLE";
    GeneralReferralCode["LOW_FICO_FOR_SECOND_HOME"] = "LOW_FICO_FOR_SECOND_HOME";
    GeneralReferralCode["LOW_SELF_REPORTED_FICO"] = "LOW_SELF_REPORTED_FICO";
    GeneralReferralCode["NO_QUALIFIED_HELOC_RATES"] = "NO_QUALIFIED_HELOC_RATES";
    GeneralReferralCode["NO_QUALIFIED_PREQUAL_RATES"] = "NO_QUALIFIED_PREQUAL_RATES";
    GeneralReferralCode["NO_RATES_EXPRESS"] = "NO_RATES_EXPRESS";
    GeneralReferralCode["NO_VEHICLE_VALUATION"] = "NO_VEHICLE_VALUATION";
    GeneralReferralCode["NON_CITIZEN"] = "NON_CITIZEN";
    GeneralReferralCode["OVER_BACK_END_RATIO"] = "OVER_BACK_END_RATIO";
    GeneralReferralCode["OVER_FRONT_END_RATIO"] = "OVER_FRONT_END_RATIO";
    GeneralReferralCode["RATES_TIMEOUT"] = "RATES_TIMEOUT";
    GeneralReferralCode["REFINANCING_OTHER_HOME"] = "REFINANCING_OTHER_HOME";
    GeneralReferralCode["STATE_NOT_SUPPORTED"] = "STATE_NOT_SUPPORTED";
    GeneralReferralCode["VENDOR_ERROR_CRS"] = "VENDOR_ERROR_CRS";
    GeneralReferralCode["VETERAN"] = "VETERAN";
    GeneralReferralCode["VOIE_NOT_AVAILABLE"] = "VOIE_NOT_AVAILABLE";
    GeneralReferralCode["WANTS_FUTURE_ESCROW"] = "WANTS_FUTURE_ESCROW";
})(GeneralReferralCode = exports.GeneralReferralCode || (exports.GeneralReferralCode = {}));
/**
 * Explicit Credit Report Conditions on referrals
 */
var CreditReportReferralCode;
(function (CreditReportReferralCode) {
    CreditReportReferralCode["BANKRUPTCY_ON_CREDIT_REPORT"] = "BANKRUPTCY_ON_CREDIT_REPORT";
    CreditReportReferralCode["CREDIT_ERROR"] = "CREDIT_ERROR";
    CreditReportReferralCode["FORECLOSURE_ON_CREDIT_REPORT"] = "FORECLOSURE_ON_CREDIT_REPORT";
    CreditReportReferralCode["FRAUD"] = "FRAUD";
    CreditReportReferralCode["FROZEN"] = "FROZEN";
    CreditReportReferralCode["LOW_FICO"] = "LOW_FICO";
    CreditReportReferralCode["NO_RECORD"] = "NO_RECORD";
    CreditReportReferralCode["PAST_DUE_ACCOUNT"] = "PAST_DUE_ACCOUNT";
})(CreditReportReferralCode = exports.CreditReportReferralCode || (exports.CreditReportReferralCode = {}));
